import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  Typography,
  IconButton,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';
import { useVisitor } from '../../context';

interface VisitorFiltersProps {
  onApplyFilters?: () => void;
}

export function VisitorFilters({ onApplyFilters }: VisitorFiltersProps) {
  const { nameFilter, setNameFilter, clearFilters } = useVisitor();
  const [localNameFilter, setLocalNameFilter] = useState(nameFilter);

  useEffect(() => {
    setLocalNameFilter(nameFilter);
  }, [nameFilter]);

  const handleApplyFilters = () => {
    setNameFilter(localNameFilter);
    onApplyFilters?.();
  };

  const handleClearFilters = () => {
    setLocalNameFilter('');
    clearFilters();
  };

  const hasActiveFilters = nameFilter.length > 0;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Filtros
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: { xs: 'stretch', sm: 'flex-end' },
          flexDirection: { xs: 'column', sm: 'row' },
          flexWrap: 'wrap',
        }}
      >
        <TextField
          label="Buscar por nome"
          placeholder="Digite o nome do participante..."
          value={localNameFilter}
          onChange={(e) => setLocalNameFilter(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleApplyFilters();
            }
          }}
          sx={{
            minWidth: { xs: '100%', sm: 250 },
            flex: { sm: 1 },
            maxWidth: { sm: '400px' },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: localNameFilter && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => setLocalNameFilter('')}
                >
                  <Clear />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            flexDirection: { xs: 'column', sm: 'row' },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={localNameFilter === nameFilter}
            sx={{
              width: { xs: '300px', md: '80px' },
              minWidth: { sm: '140px' },
            }}
          >
            Filtrar
          </Button>
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            disabled={!hasActiveFilters && !localNameFilter}
            sx={{
              width: { xs: '300px', md: '80px' },
              minWidth: { sm: '140px' },
            }}
          >
            Limpar
          </Button>
        </Box>
      </Box>
    </Box>
  );
}